import {array, boolean, number, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {stringOptionalNullable} from '@shared/utils';

export const currentUserV8nSchema = object().shape({
  username: string().required(),
  name: string().required(),
  avatar: stringOptionalNullable,
  bio: stringOptionalNullable,
  cell_phone: stringOptionalNullable,
  email: stringOptionalNullable,
});

export const userBanV8nSchema = object().shape({
  user_id: string().required(),
  comment: string().required(),
  banned_by: string().required(),
  banned_by_username: string().required(),
  banned_at: string().required(),
  lifted_at: string().nullable().optional(),
  lifted_by: string().nullable().optional(),
  lifted_by_username: string().nullable().optional(),
});

export const userBanListV8nSchema = array().of(userBanV8nSchema).required();
export const v8nSchemaOfGetUserBansResponse = paginationV8nSchema.shape({
  array: array()
    .of(userBanV8nSchema.shape({username: string().required()}))
    .required(),
});

export const userV8nSchema = object().shape({
  id: string().required(),
  username: string().required(),
  name: string().required(),
  cell_phone: stringOptionalNullable,
  avatar: stringOptionalNullable,
  email: stringOptionalNullable,
  country: string().nullable().optional(),
  is_verified: boolean().nullable().optional(),
  is_admin: boolean().nullable().optional(),
  real_funds: number().nullable().optional(),
  promo_funds: number().nullable().optional(),
  coins: number().nullable().optional(),
  cfp: number().nullable().optional(),
  auth_type: string()
    .oneOf(['phone', 'google', 'apple', 'facebook'] as const)
    .required(),
  ban: userBanV8nSchema.nullable().optional().default(null),
  registered_at: string().nullable().optional(),
  referrer: object({id: string().required(), username: string().required()})
    .nullable()
    .optional(),
});

export const v8nSchemaOfGetUsersResponse = paginationV8nSchema.shape({
  array: array().of(userV8nSchema).required(),
});

export const impersonationTokenV8nSchema = object().shape({
  access_token: string().required(),
  token_type: string().required(),
  expires_in: number().integer().required(),
});

export const userCurrencyV8nSchema = object().shape({
  currency: string().required(),
  rate: string().required(),
});

export const userExtDataV8nSchema = object().shape({
  name: string().required(),
  value: string().defined(),
  created_at: string().required(),
});

export const userExtDataListV8nSchema = array()
  .of(userExtDataV8nSchema)
  .required();
